<div class="iban-input">
  <p-inputMask name="iban"
               [(ngModel)]="value"
               (ngModelChange)="fireChanges()"
               [readonly]="disabled"
               [styleClass]="hasError ? 'p-state-error' : ''"
               mask="aa99 9999 9999 9999"
  ></p-inputMask>
</div>
